import { render } from "./QuizPageTwo.vue?vue&type=template&id=c770b26a&scoped=true"
import script from "./QuizPageTwo.vue?vue&type=script&lang=js"
export * from "./QuizPageTwo.vue?vue&type=script&lang=js"

import "./QuizPageTwo.vue?vue&type=style&index=0&id=c770b26a&scoped=true&lang=css"

import exportComponent from "/Users/curtismensah/Projects/Litt/Brit/brit-fe/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c770b26a"]])

export default __exports__